<template>
  <pie :data="chartData" :options="options" :ref="queryID"/>
</template>


<script>
import 'chart.js/auto'
import ChartHelper from "./ChartHelper"
import {Pie} from 'vue-chartjs'
// import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
//    extends: Pie,
  props: ['chartType', 'queryColumns', 'queryResult', 'chartZoomResetKey', 'queryID'],
  components: {
    Pie
  },

  mounted() {
    // Force chart update after a short delay to ensure arc geometry is calculated
    setTimeout(() => {
      if (this.$refs[this.queryID]?.chart) {
        this.$refs[this.queryID].chart.update('none')
      }
    }, 100)
  },

  watch: {
    chartZoomResetKey(){
      this.$refs[this.queryID].chart.resetZoom()
    },
    queryResult() {
      // Force update when data changes
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs[this.queryID]?.chart) {
            this.$refs[this.queryID].chart.update('none')
          }
        }, 100)
      })
    }
  },

  computed: {
    chartData() {
      if(this.queryResult && this.queryResult.length > 0){
        let result = ChartHelper.buildDataset(this.chartType, this.queryColumns, this.queryResult)
        console.log("chartData: ", result)
        return result
      }
    },

    options() {
      if(this.queryResult && this.queryResult.length > 0){
        return {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '20%',
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                title: function(context) {
                  // Hole das korrekte Label für dieses Dataset
                  const ctx = context[0]
                  const datasetIndex = ctx.datasetIndex
                  const dataIndex = ctx.dataIndex

                  // Berechne den Offset basierend auf der Summe aller vorherigen Dataset-Längen
                  let labelOffset = 0
                  for (let i = 0; i < datasetIndex; i++) {
                    labelOffset += ctx.chart.data.datasets[i].data.length
                  }

                  return ctx.chart.data.labels[labelOffset + dataIndex] || ''
                },
                label: function(context) {
                  const value = context.parsed || 0
                  const dataset = context.dataset
                  const sum = dataset.data.reduce((a, b) => a + Number(b || 0), 0)
                  const percentage = Math.round((value / sum) * 100)
                  return `${dataset.label}: ${value} (${percentage}%)`
                }
              }
            },
            datalabels: {
              formatter: (value, ctx) => {
                // Berechne den Offset basierend auf der Summe aller vorherigen Dataset-Längen
                let labelOffset = 0
                for (let i = 0; i < ctx.datasetIndex; i++) {
                  labelOffset += ctx.chart.data.datasets[i].data.length
                }

                const label = ctx.chart.data.labels[labelOffset + ctx.dataIndex]
                const sum = ctx.dataset.data.reduce((a, b) => a + Number(b || 0), 0)
                const percentage = Math.round((value / sum) * 100)
                return `${label}`
              },
              color: "white",
              font: (ctx) => {
                const sum = ctx.dataset.data.reduce((a, b) => a + Number(b || 0), 0)
                const percentage = Math.round((ctx.dataset.data[ctx.dataIndex] / sum) * 100)

                // Dynamische Schriftgröße basierend auf Prozentsatz
                let size = 12
                if (percentage < 5) {
                  size = 8
                } else if (percentage < 10) {
                  size = 10
                } else if (percentage < 15) {
                  size = 12
                }

                return {
                  size: size,
                  weight: 'bold'
                }
              },
              rotation: (ctx) => {
                if (ctx.datasetIndex !== 0) return 0

                const meta = ctx.chart.getDatasetMeta(ctx.datasetIndex)
                if (!meta || !meta.data || !meta.data[ctx.dataIndex]) return 0

                const arc = meta.data[ctx.dataIndex]
                // DataLabels caches this angle until the next update/hover.
                // Use animation targets so hover cannot replace a cached interim angle.
                const {startAngle, endAngle} = arc.getProps(['startAngle', 'endAngle'], true)

                // Prüfe ob arc-Daten verfügbar sind
                if (typeof startAngle === 'undefined' || typeof endAngle === 'undefined') {
                  return 0
                }

                // Mittlerer Winkel des Segments in Grad
                const midAngleRad = (startAngle + endAngle) / 2
                let degrees = midAngleRad * (180 / Math.PI)

                // Text radial ausrichten (senkrecht zur Tangente = parallel zur Linie zum Mittelpunkt)
                // Chart.js startet bei -90° (12 Uhr Position)
                let rotation = degrees

                // Auf der linken Seite (90° bis 270°) Text umdrehen
                if (degrees > 90 && degrees < 270) {
                  rotation = degrees + 180
                }

                return rotation
              },
              anchor: 'center',
              align: 'center',
              textAlign: 'center'
            },
            zoom: {
              zoom: {
                wheel: { enabled: true },
                pinch: { enabled: true },
                mode: 'xy',
              },
              pan: {
                enabled: true,
                mode: 'xy',
              }
            }
          }
        }
      }
    },
  }
}
</script>
